// extracted by mini-css-extract-plugin
export default {"wrapper":"W_PaymentSubscribePlanContent_wrapper__HKIKo"};